import loopback from '@/services/loopback'

const AI_MODELS_ENDPOINT = '/integrations/core/default-settings'

/**
 * Fetch the list of AI models available for payment plans from the pbxapi.
 *
 * The endpoint returns an array of objects shaped as
 *   { publicId, name, data, createdAt, updatedAt }
 * The `name` is the canonical identifier used as `aiDefaultName` on subscription items.
 *
 * @returns {Promise<Array<{ publicId: string, name: string, data: object, createdAt: string, updatedAt: string }>>}
 */
export async function getAiModels () {
  const response = await loopback.get(AI_MODELS_ENDPOINT)
  if (Array.isArray(response)) return response
  if (response && Array.isArray(response.data)) return response.data
  return []
}



// WEBPACK FOOTER //
// ./src/services/ai-models.js